export default __webpack_public_path__ + "static/media/christian_drkulec.1fd27407.gif";